<template>
  <div class="products-mdsy-page-content flex flex-col items-center w-full text-left">
    <section class="relative w-full flex flex-col items-center max-ml:hidden">
      <Pic class="w-full relative z-0 min-h-20rem  max-ml:object-cover max-ml:object-center"
        src="/images/pages/products/mdsy/banner@2x.png" alt="" />
      <PageContentCenter class="text-[#616671] absolute top-[136px]">
        <h2 class="text-42.08px text-[#102136] mb-[2rem] font-semibold">
          门店收银系统
        </h2>
        <p class="">简单好用、轻松搞定收银,让您的店铺在竞争中脱颖而出!</p>
      </PageContentCenter>
    </section>

    <section class="ml:hidden w-full">
      <Pic class="w-full" src="/images/mobile/products/mdsy.png"></Pic>
    </section>

    <section class="relative w-full text-left">
      <PageContentCenter>
        <h2 class="text-[2rem] text-[#272E3B] pt-[80px] mb-2.19rem font-bold">
          {{ content.businessIntroduction.title }}
          <span class="font-thin text-[#C2CDE5] text-1.63rem max-ml:hidden"><span class="mx-[1rem]">|</span>
            BUSINESS</span>
        </h2>
      </PageContentCenter>

      <PageContentCenter class="text-[#616671] text-[1rem] relative pb-9.8rem">

        <div class="relative flex flex-col">
          <div class="relative mb-[4rem]">
            <h3 class="relative  mb-1.14rem mdsy-business-introduction-title">
              <span class="relative z-2">{{ content.businessIntroduction.subTitle }}</span>
            </h3>
            <!-- <span class="mdsy-business-number-cooperative-stores max-ml:hidden! hidden">
              <Pic src="/images/pages/products/mdsy/Frame 427321420@2x.png" class="w-2.27rem h-2.27rem mr-[10px]"></Pic>
              <span class="text-[#777A8E] pt-[5px]">合作的门店数 <span class="text-primary">100＋</span></span>
            </span> -->

            <ul class="features-group-ul">
              <li v-for="desc in content.businessIntroduction.descList"
                class="text-[#616671] text-[1rem] mb-[1.13rem] features-group-li">{{ desc
                }}
              </li>
            </ul>
          </div>
          <ul class="flex gap-[1rem] accordion-container max-ml:hidden!" @mouseenter="stopAutoPlay"
            @mouseleave="startAutoPlay">
            <li v-for="(item, index) in content.businessIntroduction.aliasIntroduceImageList" :key="index"
              :class="['accordion-item', { 'active': activeIndex === index }]" @mouseenter="activeIndex = index"
              @mouseleave="activeIndex = -1">
              <Pic :src="item.mainImage" class="w-full h-full object-cover object-left rounded-6px overflow-hidden"
                alt="" />
            </li>
          </ul>
        </div>
      </PageContentCenter>
    </section>

    <section class="w-full ">

      <h2 class="text-[2rem] text-[#272E3B] pt-[80px] font-bold bg-[#EFF7FF]">
        <PageContentCenter>
          {{ content.featuresIntroduction.title }}
          <span class="font-thin text-[#C2CDE5] text-1.63rem max-ml:hidden"><span class="mx-[1rem]">|</span>
            FUNCTION</span>
        </PageContentCenter>
      </h2>

      <section :class="['flex', 'py-3.56rem', group.direction === 'copywriting-to-image' ? 'bg-[#EFF7FF]' : '']"
        v-for="group in content.featuresIntroduction.groups">
        <PageContentCenter
          :class="['flex', 'justify-center', 'gap-160px', 'relative', group.direction === 'image-to-copywriting' ? 'ml:flex-row-reverse' : '', 'max-ml:flex-col!', 'max-ml:gap-20px']">
          <div class="w-350px relative  align-self-center max-ml:w-full">
            <div :class="['mb-1.75rem']">
              <Pic :src="group.icon" class="w-[5.5rem] h-[5rem] mb-1.75rem max-lg:hidden"></Pic>
              <h4 class="text-1.88rem">{{ group.title }}</h4>
            </div>
            <ul class="features-group-ul">
              <li v-for="desc in group.descList" class="text-[#616671] text-[1rem] mb-[2rem] features-group-li">{{
                desc
              }}
              </li>
            </ul>
          </div>
          <Pic class="w-42.25rem max-ml:w-full" :src="group.mainImage" :style="{}"></Pic>
        </PageContentCenter>
      </section>
    </section>

    <section class="relative w-full mdsy-product-advantage h-60.38rem bg-[#EFF7FF] max-ml:hidden!">
      <h2 class="text-[2rem] text-[#272E3B] pt-[80px] font-bold bg-[#EFF7FF]">
        <PageContentCenter>
          {{ content.advantage.title }}
          <span class="font-thin text-[#C2CDE5] text-1.63rem max-ml:hidden"><span class="mx-[1rem]">|</span>
            ADVANTAGE</span>
        </PageContentCenter>
      </h2>
      <PageContentCenter class="text-[#272E3B] relative pt-10rem">
        <Pic src="/images/pages/products/mdsy/Frame 2147229614@2x.png"
          class="w-39.72rem h-[37rem] absolute left-1/2 -translate-x-1/2 "></Pic>
        <ul class="flex justify-center gap-2.44rem relative">
          <li v-for="item in content.advantage.list" class="mdsy-product-advantage-item absolute left-0 top-0">
            <div class="flex absolute gap-1.38rem" :class="[
              `text-${item.diction}`,
              item.diction === 'center' ? `flex-col-reverse align-center` : `text-${item.diction}`,
              item.diction === 'right' ? `flex-row-reverse` : ``,
              `left-${item.left}`,
              `top-${item.top}`,
            ]" :style="{
              'left': item.left,
              'top': item.top
            }">
              <Pic :src="item.icon" class="relative w-5.4rem h-5.4rem inline-block"></Pic>
              <div>
                <h5 class="text-1.25rem font-semibold  text-[#0B266C]">{{ item.title }}</h5>
                <p class="text-[#8F8F8F] text-0.88rem w-16.3rem mb-[1rem]">{{
                  item.desc }}</p>
              </div>
            </div>
          </li>
        </ul>
      </PageContentCenter>
    </section>

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { useSeoMeta } from 'nuxt/app'
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'

useSeoMeta({
  title: '门店收银系统',
  description: '门店收银系统，简单好用、轻松搞定收银，让您的店铺在竞争中脱颖而出！',
})
const activeIndex = ref(0)
// 添加定时器引用和方向控制
const timer = ref<NodeJS.Timeout | null>(null)
const direction = ref(1) // 1 表示正向，-1 表示反向
const content = shallowReactive({
  businessIntroduction: {
    title: '产品业务介绍',
    // 副标题
    subTitle: '创新收银系统为门店提供数字化解决方案,系统功能包括：',
    desc: '',
    mainImage: '/images/pages/products/mdsy/Frame 427321214@2x.png',
    descList: [
      '收银和线上下单(到店自提和线下配送)',
      '更便捷和智能化的会员、营销、订单、库存、采购、履约在同一套系统进行统一管理',
      '助力不同行业的门店提升整体坪效和管理水平'
    ],
    aliasIntroduceImageList: [
      {
        mainImage: '/images/pages/products/mdsy/Frame 2147229369@2x.png',
        alias: '#first',
        width: '47.15rem'
      },
      {
        mainImage: '/images/pages/products/mdsy/Frame 2147229370@2x.png',
        alias: '#first'
      }, {
        mainImage: '/images/pages/products/mdsy/Frame 2147229371@2x.png',
        alias: '#first'
      }, {
        mainImage: '/images/pages/products/mdsy/Frame 2147229372@2x.png',
        alias: '#first'
      }, {
        mainImage: '/images/pages/products/mdsy/Frame 2147229373@2x.png',
        alias: '#first'
      },
    ]
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    groups: [
      {
        title: '收银',
        desc: '',
        descList: [
          '包含会员余额、现金、聚合支付等多种方式',
          '支持组合支付，支持设置整单折扣率和抹零操作',
        ],
        icon: '/images/pages/products/mdsy/Frame 2147229355@2x.png',
        mainImage: '/images/pages/products/mdsy/Frame 2147229608@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '会员',
        desc: '',
        descList: ['支持会员注册,收集顾客基本信息,如姓名、手机号、生日等', '支持设置不同的充值规则模板,对会员进行充值操作',],
        icon: '/images/pages/products/mdsy/Frame 2147229476@2x.png',
        mainImage: '/images/pages/products/mdsy/Frame 2147229407@2x.png',
        direction: 'image-to-copywriting'
      },
      {
        title: '库存',
        desc: '',
        descList: ['实时更新库存数量,当商品销售、退货或调拨时,自动增减库存',],
        icon: '/images/pages/products/mdsy/Frame 2147229477@2x.png',
        mainImage: '/images/pages/products/mdsy/Frame 2147229612@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '盘点',
        desc: '',
        descList: ['盘点人员使用系统或手持终端对商品进行逐一清点,记录实际数量',],
        icon: '/images/pages/products/mdsy/Frame 2147229478@2x.png',
        mainImage: '/images/pages/products/mdsy/Frame 2147229407@2x(1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '排班管理',
        desc: '',
        descList: ['根据门店营业时间、业务量等因素,制定排班规则。交班时生成交班记录',],
        icon: '/images/pages/products/mdsy/Frame 2147229480@2x.png',
        mainImage: '/images/pages/products/mdsy/Frame 2147229613@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '门店管理',
        desc: '',
        descList: ['记录门店的基本信息,管理门店的设备信息', '对于连锁门店,可实现数据共享和统一管理',],
        icon: '/images/pages/products/mdsy/Frame 427321420@2x.png',
        mainImage: '/images/pages/products/mdsy/Frame 2147229480@2x(2).png',
        direction: 'image-to-copywriting'
      }, {
        title: '角色管理',
        desc: '',
        descList: ['定义系统中的各种角色,确保不同岗位人员只能访问和操作其权限范围内的功能和数据,防止数据泄露和误操作',],
        icon: '/images/pages/products/mdsy/Frame 2147229480@2x(1).png',
        mainImage: '/images/pages/products/mdsy/Frame 2147229409@2x.png',
        direction: 'copywriting-to-image'
      }, {
        title: '报表统计',
        desc: '',
        descList: ['为商家提供全面、准确的数据分析,帮助了解经营状况,制定决策'],
        icon: '/images/pages/products/mdsy/订单-默认@2x.png',
        mainImage: '/images/pages/products/mdsy/Frame 2147229480@2x(3).png',
        direction: 'image-to-copywriting'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    list: [
      {
        title: '专业化',
        desc: '除了基本的商品结算功能,收银机还可以提供会员、优惠券、抹零优惠、满减等营销功能,提升顾客的购物体验',
        icon: '/images/pages/products/mdsy/Frame 2147229306@2x.png',
        diction: 'center',
        left: '600px',
        top: '-135px'
      },
      {
        title: '支付方式多样化',
        desc: '集成多种支付方式,包括传统的刷卡、现金支付,以及更为流行的移动支付如微信支付、支付宝',
        briefBack: '/images/pages/products/mdsy/Group 1171274812@2x.png',
        icon: '/images/pages/products/mdsy/Frame 2147229310@2x.png',
        diction: 'left',
        left: '980px',
        top: '180px'
      },
      {
        title: '数据精准化',
        desc: '业绩统计与管理:收银机能记录销售业绩和顾客购物信息,打印多种形式的报表,为管理和决策提供依据,帮助门店更好地了解经营状况',
        icon: '/images/pages/products/mdsy/Frame 2147229309@2x.png',
        diction: 'left',
        left: '900px',
        top: '470px'
      },
      {
        title: '平台技术化',
        desc: '运用先进的AI识别算法精准识别商品,只需将商品放到托盘,立即自动识别出来,极大提升了收银效率',
        icon: '/images/pages/products/mdsy/Frame 2147229308@2x.png',
        diction: 'right',
        left: '300px',
        top: '470px'
      }, {
        title: '线上一体化',
        desc: '门店线下商品、库存、营销、财务与线上即时鸟网店统一管理,支撑门店多渠道经营',
        icon: '/images/pages/products/mdsy/Frame 2147229307@2x.png',
        diction: 'right',
        left: '200px',
        top: '180px'
      },
    ]
  }
})

// 修改自动轮播函数
const startAutoPlay = () => {
  // 清除已存在的定时器
  if (timer.value) {
    clearInterval(timer.value)
  }

  // 设置新的定时器
  timer.value = setInterval(() => {
    const length = content.businessIntroduction.aliasIntroduceImageList.length

    // 如果是初始状态(-1)，则设置为0并开始正向
    if (activeIndex.value === -1) {
      activeIndex.value = 0
      direction.value = 1
      return
    }

    // 根据方向更新索引
    if (direction.value === 1) {
      // 正向移动
      if (activeIndex.value < length - 1) {
        activeIndex.value++
      } else {
        // 到达末尾，改变方向
        direction.value = -1
        activeIndex.value--
      }
    } else {
      // 反向移动
      if (activeIndex.value > 0) {
        activeIndex.value--
      } else {
        // 到达开头，改变方向
        direction.value = 1
        activeIndex.value++
      }
    }
  }, 3100)
}

// 添加停止自动轮播函数
const stopAutoPlay = () => {
  if (timer.value) {
    clearInterval(timer.value)
    timer.value = null
  }
}

// 在组件挂载时启动自动轮播
onMounted(() => {
  startAutoPlay()
})

// 在组件卸载时清理定时器
onUnmounted(() => {
  if (timer.value) {
    clearInterval(timer.value)
  }
})
</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-mdsy-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .mdsy-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/mdsy/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 4px;
        left: 0;
        width: 1.06rem;
        height: 1.06rem;
        background-image: url("/images/pages/products/mdsy/Frame 2147229384@2x.png");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
      }
    }
  }
}

.mdsy-product-advantage {
  background-image: url("/images/pages/products/mdsy/Group 1171274840@2x.png");
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
